import { flow, without, get, filter, includes, curry, size } from 'lodash/fp';
import { connect } from 'react-redux';
import ContainerExpander from './ContainerExpander';

const mapStateToProps = ({ estimateBuilder }, { containerId, sourceItemId }) => {
  const { entities, copyStyles } = estimateBuilder;
  const container = entities.containers.byId[containerId];

  const items = flow(
    get('items'),
    without([sourceItemId]),
  )(container);

  const selectedCount = flow(
    get('selection'),
    filter(includes(curry.placeholder, items)),
    size,
  )(copyStyles);

  return {
    container,
    items,
    selectedCount,
  };
};

export default connect(mapStateToProps)(ContainerExpander);
